function copyCoupon() {
    const code = document.getElementById("couponCode").innerText;
    const button = document.getElementById("copyBtn");

    navigator.clipboard.writeText(code).then(() => {
      button.innerText = "Copied!";
      button.classList.add("copied");

      setTimeout(() => {
        button.innerText = "Copy";
        button.classList.remove("copied");
      }, 3000);
    });
  }